import { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import { AnswerSlideType } from "../../types/answerSlide";
import { OnNavigationType } from "../_basic/SlideNavigation";

interface AnswerSlideProps {
  data: AnswerSlideType;
  onNavigation: OnNavigationType;
  setPayloadValue: any;
  setShowModal: any;
  config: any;
  modalShown: boolean;
  setModalShown: any;
  sendAnalyticsData?: any;
  showModal?: any;
  buttonClicked?: any;
}

const AnswerSlide: React.FC<AnswerSlideProps> = ({
  data,
  onNavigation,
  setPayloadValue,
  setShowModal,
  config,
  setModalShown,
  modalShown,
  showModal,
  sendAnalyticsData,
  buttonClicked,
}) => {
  const [selected, setSelected] = useState<number[]>([]);

  const defaultImage = "/logo512.png";

  function toggleElement(arr: number[], element: number): number[] {
    const index = arr.indexOf(element);
    if (index === -1) arr.push(element);
    else arr.splice(index, 1);
    return arr;
  }

  const handleSelection = (index: number) => {
    if (!data.multiselect && selected.includes(index)) {
      onNavigation(1);
      return;
    }

    const updatedSelected = data.multiselect
      ? [...toggleElement(selected, index)]
      : [index];

    setSelected(updatedSelected);

    setPayloadValue(
      data.apiFieldName,
      data.type === "MULTI_ANSWER_SLIDE"
        ? updatedSelected.map((item) => data.answers[item].value)
        : data.answers[index].value
    );

    if (data.type === "SINGLE_ANSWER_SLIDE") onNavigation(1);
  };

  function getIconUrl(data: any) {
    const prefix = "https://slider-assets.cust.enpal.io/slider-images/";
    return data && data.startsWith("https://") ? data : `${prefix}${data}`;
  }

  useEffect(() => {
    if (modalShown) return;

    let inactivityTimer: NodeJS.Timeout;
    function showModalHandler() {
      if (!showModal && !buttonClicked.current) {
        setShowModal(true);
        sendAnalyticsData?.("OpenPopOverForm", "timeout");
        buttonClicked.current = true;
        setModalShown(true);
      }
    }

    function resetInactivityTimer() {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(showModalHandler, 3000);
    }

    document.addEventListener("mousemove", resetInactivityTimer);
    document.addEventListener("keydown", resetInactivityTimer);
    document.addEventListener("click", resetInactivityTimer);

    resetInactivityTimer();

    return () => {
      clearTimeout(inactivityTimer);
      document.removeEventListener("mousemove", resetInactivityTimer);
      document.removeEventListener("keydown", resetInactivityTimer);
      document.removeEventListener("click", resetInactivityTimer);
    };
  }, []);

  const openModal = () => {
    setShowModal(true);
    sendAnalyticsData?.("OpenPopOverForm", "click");
    buttonClicked.current = true;
    setModalShown(true);
  };

  return (
    <div
      className={`${styles.answerSlideContainer} ${
        data.imageLayout ? styles.verticalLayout : ""
      } ${
        !data.imageLayout && data.answers[0].image ? styles.secondaryLayout : ""
      }`}>
      <div className={styles.titleContainer}>
        <div className={styles.subTitle}>{data.subtitle}</div>
        <div className={styles.title}>
          {data.title}
          {config?.modalForm?.button && (
            <button className={styles.openModalButton} onClick={openModal}>
              {config.modalForm?.button?.text || "Open Form"}
            </button>
          )}
        </div>
      </div>
      <div
        className={`${styles.answerSlide} ${
          data.imageLayout ? styles.flexWrap : ""
        }`}>
        {data.answers.map((option, index) => (
          <div
            key={index}
            className={`${styles.card} ${
              selected.includes(index) ? styles.selected : ""
            }
            ${!option.image ? styles.textBox : ""}
            `}
            onClick={() => handleSelection(index)}>
            {option.image && (
              <div className={styles.icon}>
                <img
                  src={getIconUrl(option.image)}
                  className={styles.image}
                  alt={option.label}
                  onError={(e) => (e.currentTarget.src = defaultImage)}
                />
              </div>
            )}
            <div
              className={`${styles.label} ${
                data.answers[0].image ? "" : styles.center
              }`}>
              <p>{typeof option.label === "string" ? option.label : ""}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnswerSlide;
